import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleAdvanceHistoryQuery, SaleAdvanceHistoryQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleAdvanceHistoryQuery)
@Wrapper(SaleAdvanceHistoryQueryHandlerBase)
export class SaleAdvanceHistoryQueryHandler {
    public constructor(
        http: Http
    ) { }
}
